module.exports = __webpack_public_path__ + "media/images/emblems/PerlyCertoux-coat_of_arms-d1bd275a27a5ec35580f85d3c8a4dbb9.svg";